import { useAccess } from "features/Authentication/hooks/useAccess";
import { Navigate, useParams } from "react-router-dom";

const RequirePermission = ({
  permission,
  children,
}: {
  permission: string | string[];
  children: any;
}) => {
  const { can } = useAccess();
  const { id } = useParams<{ id: string }>();

  const ownerId = id ? Number(id) : undefined;

  const permissions = Array.isArray(permission) ? permission : [permission];
  if (!permissions.some((p) => can(p, { ownerId }))) {
    return <Navigate to="/unauthorized" replace />;
  }
  return children;
};

export default RequirePermission;
